import { useRelocationRecord } from "@/app/Relocations/Hooks/useRelocationRecord";
import { WorkOrderFlowById } from "@/app/ProDrivers/WorkOrders/Components/WorkOrderFlow";
import { Component, ReactNode } from "react";

class FlowErrorBoundary extends Component<
  { children: ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 text-center text-sm text-gray-500">
          Unable to load work order flow
        </div>
      );
    }
    return this.props.children;
  }
}

export function RelocationWorkOrdersCard() {
  const record = useRelocationRecord();

  if (record.workOrders.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-gray-900">Pro Drivers</h2>
      {record.workOrders.map((workOrder) => (
        <FlowErrorBoundary key={workOrder.id}>
          <WorkOrderFlowById workOrderId={workOrder.id} />
        </FlowErrorBoundary>
      ))}
    </div>
  );
}
